import React, { useState } from 'react';
import { useDatepicker } from "@datepicker-react/hooks";
import { format } from 'date-fns';
import { CalendarContext, calendarViews, getToday, getYearsData } from "./utils";
import Month from "./components/Month";
import Months from "./components/Months";
import Years from "./components/Years";
import { trackEvent } from '../../../../libraries/_modules/tracking/helpers';
import { getCultureLocalizer } from '../../utils';
import useCalendarDots from './hooks/useCalendarDots';

function Calendar({ currentMonth, setCurrentDatePoint, closeModal, setCurrentYear, currentYear,
  seasonSportecId, competitionSportecId, clubSportecId, minDate, maxDate }) {

  const [view, setView] = useState(calendarViews.days);
  const [currentDate, setCurrentDate] = useState(currentMonth);

  const today = getToday();
  const yearsData = getYearsData(currentDate, { minDate, maxDate });
  const { disablePreviousYears, disableNextYears } = yearsData;

  const handleDateSelect = (date) => {
    closeModal();
    setCurrentDatePoint(date);

    trackEvent('date-picker-click', {
      selection: format(date, 'MMM dd yyyy', { locale: getCultureLocalizer() })
    });
  };

  const {
    firstDayOfWeek,
    activeMonths,
    isDateSelected,
    isDateHovered,
    isFirstOrLastSelectedDate,
    isDateBlocked,
    isDateFocused,
    focusedDate,
    onDateHover,
    onDateFocus,
    goToPreviousMonths,
    goToNextMonths,
  } = useDatepicker({
    numberOfMonths: 1,
    initialVisibleMonth: currentMonth,
  });

  const { allMonthsMatches } = useCalendarDots({
    seasonSportecId,
    competitionSportecId,
    clubSportecId,
    activeMonth: activeMonths?.[0]?.date,
  });

  return (
    <CalendarContext.Provider
      value={{
        yearsData,
        focusedDate,
        isDateFocused,
        isDateSelected,
        isDateHovered,
        isDateBlocked,
        setView,
        setCurrentYear,
        currentYear,
        isFirstOrLastSelectedDate,
        onDateSelect: (e, date) => {
          if (e instanceof Date) {
            handleDateSelect(e);
          } else {
            handleDateSelect(date);
          }
        },
        onTodaySelect: () => {
          handleDateSelect(today);
        },
        onDateFocus,
        onDateHover,
        setCurrentDate,
        currentDate,
        activeMonths,
        minDate,
        maxDate,
        disablePreviousYears,
        disableNextYears,
      }}>
      <div className="mls-o-calendar">
        {activeMonths.map(month => {
          return (
            view === calendarViews.days
              ? (
                <Month
                  mlsCalendarMatchesData={allMonthsMatches}
                  goToPreviousMonths={goToPreviousMonths}
                  goToNextMonths={goToNextMonths}
                  key={`${month.year}-${month.month}`}
                  year={month.year}
                  month={month.month}
                  firstDayOfWeek={firstDayOfWeek}
                />
              )
              : view === calendarViews.months
                ? <Months key={`${month.year}-${month.month}`}
                />
                : <Years key={`${month.year}-${month.month}`} />
          );
        })}
      </div>
    </CalendarContext.Provider>
  );
}

export default Calendar;
